import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BiRightArrow } from "react-icons/bi";
import "./searchmovies.css";

const SearchMovies = () => {
  const [searchMovie, setSearchMovie] = useState("");
  const [movieApi, setMovieApi] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getMovie = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const response = await fetch(
      `https://api.themoviedb.org/3/search/movie?api_key=375735221c3b7b45a786c79616eae571&query=${searchMovie}&language=en-US`
    );
    const data = await response.json();
    // console.log(data.results);
    setMovieApi(data.results);
    setIsLoading(false);
    // setSearchMovie("");
  };

  useEffect(() => {
    getMovie();
  }, []);

  return (
    <>
      <div className="search_container">
        <form onSubmit={getMovie}>
          <div className="input_and_btn">
            <input
              className="search_field"
              type="text"
              value={searchMovie}
              onChange={(e) => setSearchMovie(e.target.value)}
              required
              placeholder="Search Your Favourite Movies"
            />
            <button className="search_btn">
              Search Movies
              <span>
                <BiRightArrow />
              </span>
            </button>
          </div>

          <div className="suggest-box">
            {movieApi.filter((mov) => {
              const inputText = searchMovie.toLowerCase();
              const movieText = mov.original_title.toLowerCase();
              console.log(inputText, "InputText");
              console.log("movieText", movieText);
              return inputText === movieText;
            })}
          </div>
        </form>
        <div className="search_card">
          <div>
            <div className="card__title">
              {movieApi.length === 0 ? (
                <p className="title-section">No Movies Found</p>
              ) : (
                <p className="title-section">
                  Search Results for: {searchMovie}
                </p>
              )}
            </div>
            <div className="popular">
              {!isLoading &&
                movieApi &&
                movieApi.map((movie) => (
                  <Link key={movie.original_title} to={`/movie/${movie.id}`}>
                    <div className="card">
                      <img
                        className="card-image"
                        src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                        alt="movie"
                      />
                      <div className="card__content">
                        <p className="card-title">{movie.original_title}</p>
                        <p className="card_rating">
                          {movie.vote_average} <i className="fa fa-star"></i>
                        </p>
                        <p className="card_desc">{movie.overview}</p>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <p
          style={{
            fontSize: "50px",
            color: "red",
            textAlign: "center",
            marginTop: "50px",
            padding: "100px 0",
            fontWeight: "bold",
          }}
        >
          Loading......
        </p>
      )}
    </>
  );
};

export default SearchMovies;
